<template>
  <div style="position: absolute; bottom: 0; top: 0; right: 0; left: 0">
    <div style="position: absolute; bottom: 0; top: 0; width: 300px; left: 0; overflow: auto" class="blue-grey lighten-5">
      <a-loader v-if="loading" />
      <div style="margin-right: 10px">
        <div style="width: 100%">
          <input style="padding-right: 45px" class="whatsapp-input" v-model="filtersNumber" placeholder="Поиск по номеру" />
        </div>
        <div class="pa-2 ml-1" style="position: absolute; right: 0; top: 0">
          <v-btn icon @click="search(filtersNumber)" title="Поиск"><v-icon>fas fa-search </v-icon></v-btn>
        </div>
      </div>
      <div style="position: absolute; bottom: 0px; top: 51px; width: 300px; left: 0px; overflow: auto" ref="chat_clients_block">
        <div>
          <v-list three-line>
            <v-list-item-group v-model="selected">
              <template v-for="(item, index) in data">
                <v-list-item
                  @click="
                    selected = index;
                    number = item.wa_number;
                  "
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.wa_number }}</v-list-item-title>

                      <v-list-item-subtitle class="text--primary">{{ item.name }} </v-list-item-subtitle>
                      <!-- <v-list-item-subtitle class="text--primary">{{ item.wa_last
                                    }} </v-list-item-subtitle> -->
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-action-text class="pink--text">{{ item.user_name }}</v-list-item-action-text>
                      <v-list-item-action-text v-if="item.wa_last">{{ new Date(item.wa_last).toLocaleDateString("ru") }}</v-list-item-action-text>
                      <v-list-item-action-text v-if="item.wa_last">{{
                        new Date(item.wa_last).toLocaleTimeString("ru", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      }}</v-list-item-action-text>

                      <v-badge style="margin-top: 20px; margin-right: 17px" v-if="item.wa_unviewed > 0" color="green" :content="item.wa_unviewed"></v-badge>
                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-divider v-if="index < data.length - 1" :key="index"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </div>
      </div>
      <v-btn @click="showClientDialog = true" v-show="!showClientDialog" color="pink" dark absolute right fab style="bottom: 12px">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <client-dialog v-model="showClientDialog" />
      <!-- <v-list v-model="selected">
                <template v-for="(item, index) in data">
                <v-list-item link class="py-4"  :key="index"
                    @click="selected = index; number = item.whatsapp">
                    <div>{{ item.marka }} {{ item.model }} <br> {{ item.name }} <small>{{ item.whatsapp }}</small> </div>
                </v-list-item>
                <v-divider />
            </template>
            </v-list> -->
    </div>
    <div style="position: absolute; bottom: 0; top: 0; right: 0; left: 300px">
      <chat-block style="position: absolute; bottom: 0; top: 0; right: 0; left: 0" :number="number" @close="number = ''" :isAll="isAll" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    chatBlock: () => import("./chatBlock.vue"),
    //   clientDialog: () => import("../clientsDialog.vue"),
  },
  props: {
    data: Array,
    loading: Boolean,
    isAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showClientDialog: false,
      number: "",
      selected: null,
      filtersNumber: "",
    };
  },
  watch: {
    showClientDialog() {
      if (!this.showClientDialog) {
      }
    },
  },
  mounted() {
    document.addEventListener("scroll", this.onScroll, true);
    this.$root.$on("websocket", this.registerWS);
    this.$root.$on("set_viewed_wa", this.registerSetViewed);
  },
  destoyed() {
    this.$root.$off("websocket", this.registerWS);
    this.$root.$off("set_viewed_wa", this.registerSetViewed);
    document.removeEventListener("scroll", this.onScroll, true);
  },
  methods: {
    onScroll(e) {
      if (this.$refs.chat_clients_block) {
        let el = this.$refs.chat_clients_block;
        let offset = 200;
        if (e.target == el) {
          if (el.scrollHeight - el.offsetHeight <= el.scrollTop + offset) {
            this.$emit("onScrollEnd");
          }
        }
      }
    },
    search(number) {
      let n = number.replace(/\D/g, "").substring(1);
      this.$emit("search", n);
    },
    registerWS(data) {
      if (data && data.e == "whatsapp") {
        const r = data.r;
        if (r.direction == 1 && r.viewed == 0) {
          for (const el of this.data) {
            if (el.wa_number == r.sender_number) {
              el.wa_unviewed++;
            }
          }
        }
      }
    },
    registerSetViewed(data) {
      for (const el of this.data) {
        if (el.wa_number == data.sender_number) {
          el.wa_unviewed = 0;
        }
      }
    },
    registerIncome(data) {
      for (const el of this.data) {
        if (el.wa_number == data.sender_number) {
          el.wa_unviewed++;
        }
      }
    },
    showDateTime(item) {
      let d = new Date(item);
      return d.toLocaleString("ru");
    },
  },
};
</script>
